import { getEnvVar } from '@shoflo/polymer/utils/getEnvVar';
import { Socket } from '@shoflo/polymer/utils/socket/Socket';
import { SCREEN_PRESENTER } from '@shoflo/polymer/constants/SourceItems';
import { SOURCE_ROLE_SPEAKER } from '@shoflo/polymer/constants/SourceRoleTypes';
import { MEETING_ENDED_MODAL } from '@shoflo/polymer/constants/ModalTypes';
import { StudioLogger } from '@studio/logger/StudioLogger';
import moment from 'moment';
import _ from 'underscore';

import syncProgram from 'actions/Broadcast/program/syncProgram';
import syncSources from 'actions/Broadcast/sources/syncSources';
import deleteSource from 'actions/Broadcast/sources/deleteSource';
import syncOverlays from 'actions/Broadcast/overlays/syncOverlays';
import syncRecordings from 'actions/Broadcast/recording/syncRecordings';
import syncBackgrounds from 'actions/Broadcast/backgrounds/syncBackgrounds';
import syncSceneLayers from 'actions/Broadcast/sceneLayers/syncSceneLayers';
import setMixerAttendee from 'actions/Broadcast/attendees/setMixerAttendee';
import syncBannerStatus from 'actions/Broadcast/banners/syncBannerStatus';
import syncOverlayStatus from 'actions/Broadcast/overlays/syncOverlayStatus';
import syncOverlayPosition from 'actions/Broadcast/overlays/syncOverlayPosition';
import syncBackgroundPosition from 'actions/Broadcast/backgrounds/syncBackgroundPosition';
import setAttendeeCameraStatus from 'actions/Broadcast/attendees/setAttendeeCameraStatus';
import setAttendeeConnectionMetric from 'actions/Broadcast/attendees/setAttendeeConnectionMetric';
import muteMeetingAudioAction from 'actions/Broadcast/settings/muteMeetingAudio';
import updateSource from 'actions/Broadcast/sources/updateSource';
import syncBroadcastSettings from 'actions/Broadcast/settings/syncBroadcastSettings';
import createSandboxMeeting from 'actions/Broadcast/meeting/createSandboxMeeting';
import setAttendeeDetails from 'actions/Broadcast/attendees/setAttendeeDetails';
import setSceneLayout from 'actions/Broadcast/program/setSceneLayout';
import cancelDisconnectSource from 'actions/Broadcast/sources/cancelDisconnectSource';
import setMultipleAttendeeMuteStatuses from 'actions/Broadcast/attendees/setMultipleAttendeeMuteStatuses';
import removeDesiredAttendeeCamera from 'actions/Broadcast/attendees/removeDesiredAttendeeCamera';
import getOrSyncScenes from 'actions/Broadcast/scene/getOrSyncScenes';
import setIsInitializing from 'actions/Broadcast/sources/setIsInitializing';
import setProgram from 'actions/Broadcast/program/setProgram';

import setAttendeeMuteStatus from '@shoflo/studio-redux/actions/attendee/setAttendeeMuteStatus';
import toggleAgoraAttendeeMuteStatus from '@shoflo/studio-redux/actions/attendee/toggleAgoraAttendeeMuteStatus';
import setAgoraAttendeeCameraStatus from '@shoflo/studio-redux/actions/attendee/setAttendeeCameraStatus';
import syncBackgroundStatus from '@shoflo/studio-redux/actions/background/syncBackgroundStatus';
import syncBanners from '@shoflo/studio-redux/actions/banner/syncBanners';
import syncBrandingSettings from '@shoflo/studio-redux/actions/branding/syncBrandingSettings';
import getCurrentBroadcast from '@shoflo/studio-redux/actions/broadcast/getCurrentBroadcast';
import requestReceived from '@shoflo/studio-redux/actions/knock/requestReceived';
import clearDirectorRequest from '@shoflo/studio-redux/actions/knock/clearDirectorRequest';
import knockReceived from '@shoflo/studio-redux/actions/knock/knockReceived';
import clearKnock from '@shoflo/studio-redux/actions/knock/clearKnock';
import cancelKnock from '@shoflo/studio-redux/actions/knock/cancelKnock';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import showNotification from '@shoflo/studio-redux/actions/notification/showNotification';
import syncFeaturedPresenter from '@shoflo/studio-redux/actions/program/syncFeaturedPresenter';
import toggleProgramSource from '@shoflo/studio-redux/actions/program/toggleProgramSource';
import {
  decreaseScreenShare,
  setScreenShare
} from '@shoflo/studio-redux/actions/screenShare/setScreenShare';
import setServerTimeDelta from '@shoflo/studio-redux/actions/serverTime/setServerTimeDelta';
import getSources from '@shoflo/studio-redux/actions/source/getSources';

import takeGenericPresenterLive from '@shoflo/studio-redux/actions/source/takeGenericPresenterLive';

import {
  toggleLocalUserVideoTrack,
  toggleLocalUserAudioTrack
} from '@shoflo/studio-redux/utils/actionUtils';

import {
  KNOCKED,
  BANNER_ADDED,
  OVERLAY_ADDED,
  SCENE_DELETED,
  SOURCE_TOGGLED,
  KNOCK_ANSWERED,
  BANNER_UPDATED,
  SOURCE_CREATED,
  BANNER_DELETED,
  OVERLAY_DELETED,
  BACKGROUND_ADDED,
  ENDPOINT_CREATED,
  ENDPOINT_DELETED,
  ENDPOINT_UPDATED,
  BACKGROUND_DELETED,
  PRESENTER_FEATURED,
  DIRECTOR_REQUESTED,
  BANNER_LIVE_TOGGLED,
  AGORA_SCREEN_SHARE_STOPPED,
  SCENE_LAYERS_UPDATED,
  STREAM_STATE_TOGGLED,
  OVERLAY_LIVE_TOGGLED,
  SOURCE_ORDER_CHANGED,
  BROADCAST_MIXER_JOINED,
  BACKGROUND_LIVE_TOGGLED,
  ATTENDEE_ROSTER_CHANGED,
  ATTENDEE_CAMERA_REMOVED,
  OVERLAY_POSITION_TOGGLED,
  DIRECTOR_REQUEST_ANSWERED,
  BROADCAST_PROGRAM_CHANGED,
  ATTENDEE_MIC_STATUS_CHANGED,
  BACKGROUND_POSITION_TOGGLED,
  BROADCAST_RECORDING_STARTED,
  BROADCAST_RECORDING_STOPPED,
  ATTENDEE_CONNECTION_METRICS_CHANGED,
  BROADCAST_RECORDING_CREATED,
  ATTENDEE_LEFT,
  BROADCAST_RECORDING_UPDATED,
  BROADCAST_RECORDING_DELETED,
  REAL_TIME,
  MUTE_MEETING_AUDIO_CHANGED,
  SCENE_CREATED,
  SCENE_UPDATED,
  TOGGLED_AGORA_PRESENTER_LIVE,
  AUTO_MUTE_TOGGLED,
  BROADCAST_JOIN_SYNCED_SERVER_TIME,
  KNOCK_UPDATED,
  INITIALIZED_READINESS_CHECK,
  SCENE_LAYOUT_CHANGED,
  CANCELLED_REQUESTS,
  KNOCK_REJECTED,
  KNOCK_FAILED,
  ATTENDEE_SCREEN_SHARE_CANCELLED,
  MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGED,
  TOGGLED_LAYOUT_ANIMATION,
  TOGGLED_ADD_SELF_LIVE,
  MULTIPLE_CAMERA_STATUSES_CHANGED,
  //RENEWED_MEETING,
  SYNCED_BRANDING_SETTINGS,
  SOURCE_DELETED,
  AGORA_ATTENDEE_MUTE_UNMUTE_CHANGED,
  AGORA_CAMERA_STATUS_CHANGED
} from 'store/eventConstants';

import isScenePreview from 'store/utils/isScenePreview';
import { getBroadcastRouteMatch } from 'actions/utils';
import { getCurrentUserId } from 'actions/Broadcast/utils';
import syncEndpoints from 'actions/Broadcast/stream/syncEndpoints';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';
import {
  showWebSocketReconnectionMessage,
  showRealtimeErrorMessageModal
} from 'utils/realtimeSocketConnectionHelper';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/ModalTypes';
import { REALTIME_CONNECTION_TIMEOUT_VALUE } from '../constants/appConstants';
import { getProgramLayers } from '../utils/broadcastSourceHelper';
import { processIncomingRealtimeMessage } from './socket-handlers/processIncomingRealtimeMessage';
import { BROADCAST_SCENE_SYNC } from 'actions/Types';

import { MIXER_TASK_FAILED } from '@studio/constants/SocketEvents';

const logger = new StudioLogger('socket-dispatcher');

/**
 * This class connects the redux store to the socket connection,
 * and manages joining / leaving event socket.io rooms as the event changes
 */
export default function () {
  this.connect = function () {
    // Create a new socket object
    this._socket = new Socket(getEnvVar('REACT_APP_SF_REALTIME_ENDPOINT'));
    return this._socket;
  };

  this.sameUser = userId => {
    const { user } = this._store.getState();
    if (userId) {
      return getCurrentUserId(user) === userId;
    }
    // this is to avoid loop conditions instances on socket events
    // where the user is not defined, which are historically many
    return true;
  };

  /*
    returns boolean if attendeeId is same sending director updates
  */
  this.sameAttendee = attendeeId => {
    const { meeting } = this._store.getState();
    const AttendeeId =
      meeting &&
      meeting.attendeeResponse &&
      meeting.attendeeResponse.Attendee.AttendeeId;
    return AttendeeId === attendeeId;
  };

  this.getEventIdFromRoute = () => {
    const { params } = getBroadcastRouteMatch(this._store.getState);
    return params.eventId;
  };

  this.hasRealTimeCollaborationAccess = () => {
    const { user } = this._store.getState();
    const eventId = this.getEventIdFromRoute();
    const userEvents = user?.events?.filter(evt => evt.event === eventId);
    const currentEvent = (userEvents && userEvents[0]) || Object.create(null);
    return currentEvent?.role !== 'readOnly';
  };

  this.isMeetingEndedModalOpen = () => {
    const { modal } = this._store.getState();
    return modal?.type === MEETING_ENDED_MODAL;
  };

  this.bindToStore = function (store) {
    this._store = store;
    const handleProgramChange = ({ program, notifyingDirector }) => {
      //const { meeting } = this._store.getState();
      //const { params } = getBroadcastRouteMatch(this._store.getState);
      // if its the scenePreview, ignore this
      if (!isScenePreview.call({ store })) {
        if (!this.sameAttendee(notifyingDirector)) {
          this._store.dispatch(syncProgram({ program, notifyingDirector }));
        }
      }
    };

    socketReconnected(this._socket, this._store);
    socketDisconnected(this._socket, this._store);
    socketConnected(this._socket, this._store);

    this.deletesourceByAttendeeId = attendeeId => {
      const { broadcastSources } = store.getState();
      const source = broadcastSources.sources.find(s => s.value === attendeeId);
      if (source) {
        store.dispatch(deleteSource(source._id));
      }
    };

    this.setSourceUnassignedByAttendeeId = (attendeeId, closedOrReloadTab) => {
      //we have a lambda to handle when the attendee is already in the meeting that is likely not working correctly
      //removed the code that filtered out sources that were not in a pending state.

      const { broadcastSources, program } = store.getState();
      const sources = broadcastSources.sources.filter(s =>
        [attendeeId, `${attendeeId}#content`].includes(s.value)
      );

      const layers = getProgramLayers(program);

      if (sources.length) {
        sources.forEach(source => {
          const [layerSource] = layers.filter(
            layer => layer.source._id === source._id
          );
          // Remove if source is in program
          if (!!layerSource) {
            store.dispatch(toggleProgramSource(source, setProgram));
          }
          store.dispatch(updateSource(source._id, { value: UNASSIGNED }));
          store.dispatch(removeDesiredAttendeeCamera(source.value));
          /** Resent initializing state of attendee source */
          store.dispatch(
            setIsInitializing(source.value, {
              isInitializing: false,
              isAttendee: true
            })
          );
          if (source.type === SCREEN_PRESENTER) {
            store.dispatch(decreaseScreenShare());
          }
        });

        if (closedOrReloadTab) {
          window.setTimeout(() => {
            sources.forEach(source => {
              store.dispatch(cancelDisconnectSource(source._id));
            });
          }, 3000);
        }
      }
    };
    // =================================== SOCKET EVENT LISTENERS ===================================//
    this._socket.on(BROADCAST_PROGRAM_CHANGED, handleProgramChange);

    this._socket.on(STREAM_STATE_TOGGLED, ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        this._store.dispatch(syncEndpoints());
      }
    });

    this._socket.on(KNOCKED, payload => {
      if (
        this.hasRealTimeCollaborationAccess() &&
        !this.isMeetingEndedModalOpen()
      ) {
        this._store.dispatch(knockReceived(payload));
      }
    });

    this._socket.on(KNOCK_ANSWERED, ({ knockId, ...restPayload }) => {
      this._store.dispatch(clearKnock({ _id: knockId, ...restPayload }));
    });

    this._socket.on(KNOCK_REJECTED, ({ knockId, ...restPayload }) => {
      this._store.dispatch(clearKnock({ _id: knockId, ...restPayload }));
    });

    this._socket.on(KNOCK_FAILED, ({ knockId, ...restPayload }) => {
      this._store.dispatch(clearKnock({ _id: knockId, ...restPayload }));
    });

    this._socket.on(BROADCAST_MIXER_JOINED, ({ attendeeId }) => {
      store.dispatch(setMixerAttendee(attendeeId));
    });

    this._socket.on(
      AGORA_ATTENDEE_MUTE_UNMUTE_CHANGED,
      async ({ attendeeId, isMuted, notifyingAttendee }) => {
        // Ignore the event if the notifying attendee is the local user
        const shouldIgnoreEvent = this.sameAttendee(notifyingAttendee);
        if (shouldIgnoreEvent) return;

        const { meeting, user } = this._store.getState();
        const localAttendeeId = `user-${user._id}`;

        const localAudioTrack = meeting.client.localTracks.find(
          ({ trackMediaType }) => trackMediaType === 'audio'
        );

        if (attendeeId === localAttendeeId) {
          await toggleLocalUserAudioTrack({
            currentAudioTrack: localAudioTrack,
            isMuted,
            client: meeting.client,
            dispatch: this._store.dispatch,
            isRemoteToggle: true
          });
        }

        this._store.dispatch(setAttendeeMuteStatus(attendeeId, isMuted));
      }
    );

    this._socket.on(
      AGORA_CAMERA_STATUS_CHANGED,
      async ({ attendeeId, isCameraOn, notifyingAttendee }) => {
        // Ignore the event if the notifying director is the local user
        const shouldIgnoreEvent = this.sameAttendee(notifyingAttendee);
        if (shouldIgnoreEvent) return;
        const {
          meeting: { attendeeTiles, client },
          user
        } = this._store.getState();
        const localAttendeeId = `user-${user._id}`;
        const localVideoTrack = attendeeTiles[localAttendeeId];
        const isLocalUser = attendeeId === localAttendeeId;

        if (isLocalUser) {
          await toggleLocalUserVideoTrack({
            currentVideoTrack: localVideoTrack,
            isCameraOn,
            client,
            dispatch: this._store.dispatch,
            attendeeId,
            isRemoteToggle: true
          });
        }

        this._store.dispatch(
          setAgoraAttendeeCameraStatus(attendeeId, isCameraOn, setProgram)
        );
      }
    );

    this._socket.on(
      ATTENDEE_CONNECTION_METRICS_CHANGED,
      ({ attendeeId, metrics }) => {
        // TODO: throttle this?
        store.dispatch(setAttendeeConnectionMetric(attendeeId, metrics));
      }
    );

    this._socket.on(
      ATTENDEE_CAMERA_REMOVED,
      async ({ attendeeId, isCameraOn }) => {
        store.dispatch(setAttendeeCameraStatus(attendeeId, isCameraOn));
      }
    );

    /**
     * This Socket handles when the presenter requests for director permission to share resource.
     */
    this._socket.on(DIRECTOR_REQUESTED, async payload => {
      if (this.hasRealTimeCollaborationAccess()) {
        store.dispatch(requestReceived(payload));
      }
    });

    this._socket.on(DIRECTOR_REQUEST_ANSWERED, payload => {
      if (this.hasRealTimeCollaborationAccess()) {
        this._store.dispatch(clearDirectorRequest(payload));
      }
    });

    this._socket.on(SOURCE_TOGGLED, async ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(getSources());
      }
    });

    this._socket.on(SOURCE_CREATED, async ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(getSources());
      }
    });

    this._socket.on(SOURCE_DELETED, async ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(getSources());
      }
    });

    this._socket.on(
      ATTENDEE_ROSTER_CHANGED,
      async ({ notifyingDirector, attendeeRoster }) => {
        const { attendeeRoster: localAttendeeRoster } = this._store.getState();

        if (notifyingDirector && !this.sameAttendee(notifyingDirector)) {
          if (!_.isEqual(attendeeRoster, localAttendeeRoster)) {
            store.dispatch(getSources());
          }
        }
      }
    );

    this._socket.on(
      ATTENDEE_MIC_STATUS_CHANGED,
      async ({ attendeeId, isMuted }) => {
        store.dispatch(setAttendeeMuteStatus(attendeeId, isMuted));
      }
    );

    this._socket.on(
      MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGED,
      async muteStatuses => {
        store.dispatch(setMultipleAttendeeMuteStatuses(muteStatuses));
      }
    );

    this._socket.on(AGORA_SCREEN_SHARE_STOPPED, async ({ attendeeId }) => {
      const {
        meeting: { screenShare, attendeeId: localAttendeeId }
      } = store.getState();
      const { client, videoTrack, audioTrack } = screenShare;

      const localScreenShareId = `${localAttendeeId}#content`;

      if (localScreenShareId === attendeeId) {
        const { stopScreenShare } = await import(
          '@cvent/studio-agora/screenShare/screenShareHelper'
        );
        await stopScreenShare(client, videoTrack, audioTrack);
      }
      this.setSourceUnassignedByAttendeeId(attendeeId);
      store.dispatch(setScreenShare(true));
    });

    this._socket.on(OVERLAY_ADDED, async ({ notifyingAttendee }) => {
      if (!this.sameAttendee(notifyingAttendee)) {
        store.dispatch(syncOverlays());
      }
    });

    this._socket.on(OVERLAY_DELETED, async () => {
      store.dispatch(syncOverlays());
    });

    this._socket.on(BACKGROUND_ADDED, async () => {
      store.dispatch(syncBackgrounds());
    });

    this._socket.on(BACKGROUND_DELETED, async () => {
      store.dispatch(syncBackgrounds());
    });

    this._socket.on(BANNER_ADDED, async () => {
      store.dispatch(syncBanners());
    });

    this._socket.on(BANNER_DELETED, async () => {
      store.dispatch(syncBanners());
    });

    this._socket.on(
      OVERLAY_LIVE_TOGGLED,
      async ({ overlayId, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncOverlayStatus(overlayId));
        }
      }
    );

    this._socket.on(
      BACKGROUND_LIVE_TOGGLED,
      async ({ backgroundId, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncBackgroundStatus(backgroundId));
        }
      }
    );

    this._socket.on(
      OVERLAY_POSITION_TOGGLED,
      async ({ overlayId, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncOverlayPosition(overlayId));
        }
      }
    );

    this._socket.on(
      BACKGROUND_POSITION_TOGGLED,
      async ({ backgroundId, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncBackgroundPosition(backgroundId));
        }
      }
    );

    this._socket.on(
      BANNER_LIVE_TOGGLED,
      async ({ bannerId, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncBannerStatus(bannerId));
        }
      }
    );

    this._socket.on(BANNER_UPDATED, async ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(syncBanners());
      }
    });

    this._socket.on(
      SCENE_LAYERS_UPDATED,
      async ({ notifyingDirector, sceneLayers }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncSceneLayers(sceneLayers));
        }
      }
    );

    this._socket.on(ENDPOINT_CREATED, async () => {
      store.dispatch(syncEndpoints());
    });

    this._socket.on(ENDPOINT_DELETED, async () => {
      store.dispatch(syncEndpoints());
    });

    this._socket.on(ENDPOINT_UPDATED, async () => {
      store.dispatch(syncEndpoints());
    });

    this._socket.on(
      PRESENTER_FEATURED,
      async ({ notifyingDirector, presenterId }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncFeaturedPresenter(presenterId));
        }
      }
    );

    this._socket.on(
      SOURCE_ORDER_CHANGED,
      async ({ presenterId, isPresenterSource, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          if (isPresenterSource) {
            store.dispatch(syncFeaturedPresenter(presenterId));
          } else {
            store.dispatch(syncSources());
          }
        }
      }
    );

    this._socket.on(
      AUTO_MUTE_TOGGLED,
      async ({ autoMutePresenters, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncBroadcastSettings({ autoMutePresenters }));
        }
      }
    );

    /**
     * This Socket handles when the presenter is leaving the meeting.
     */
    this._socket.on(
      ATTENDEE_LEFT,
      async ({ attendeeId, closedOrReloadTab, isPresenterDismissed }) => {
        if (!isPresenterDismissed) {
          this.setSourceUnassignedByAttendeeId(attendeeId, closedOrReloadTab);
        }
      }
    );

    this._socket.on(BROADCAST_RECORDING_STARTED, async () => {
      store.dispatch(syncRecordings());
    });

    this._socket.on(BROADCAST_RECORDING_STOPPED, async () => {
      store.dispatch(syncRecordings());
    });

    this._socket.on(BROADCAST_RECORDING_CREATED, async () => {
      store.dispatch(syncRecordings());
    });

    this._socket.on(BROADCAST_RECORDING_UPDATED, async () => {
      store.dispatch(syncRecordings());
    });

    this._socket.on(BROADCAST_RECORDING_DELETED, async () => {
      store.dispatch(syncRecordings());
    });

    this._socket.on(
      MUTE_MEETING_AUDIO_CHANGED,
      async ({ muteMeetingAudio, notifyingDirector }) => {
        const { broadcastSettings } = store.getState();
        if (!this.sameAttendee(notifyingDirector)) {
          if (
            broadcastSettings &&
            broadcastSettings.muteMeetingAudio !== muteMeetingAudio
          ) {
            store.dispatch(muteMeetingAudioAction({ muteMeetingAudio }));
          }
        }
      }
    );

    this._socket.on(REAL_TIME, async payload => {
      processIncomingRealtimeMessage.call({ store, payload });
    });

    this._socket.on(SCENE_DELETED, async ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(getOrSyncScenes(BROADCAST_SCENE_SYNC));
      }
    });

    this._socket.on(SCENE_CREATED, async ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(getOrSyncScenes(BROADCAST_SCENE_SYNC));
      }
    });

    this._socket.on(
      TOGGLED_LAYOUT_ANIMATION,
      async ({ notifyingDirector, layoutAnimations }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncBroadcastSettings({ layoutAnimations }));
        }
      }
    );

    this._socket.on(
      TOGGLED_ADD_SELF_LIVE,
      async ({ notifyingDirector, addSelfLive }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(syncBroadcastSettings({ addSelfLive }));
        }
      }
    );

    this._socket.on(SCENE_UPDATED, ({ notifyingDirector }) => {
      if (!this.sameAttendee(notifyingDirector)) {
        store.dispatch(getOrSyncScenes(BROADCAST_SCENE_SYNC));
      }
    });

    this._socket.on(
      SCENE_LAYOUT_CHANGED,
      async ({ layout, notifyingDirector }) => {
        if (!this.sameAttendee(notifyingDirector)) {
          store.dispatch(setSceneLayout(layout));
        }
      }
    );

    this._socket.on(TOGGLED_AGORA_PRESENTER_LIVE, ({ attendeeId }) => {
      const { broadcastSources } = store.getState();
      const source = broadcastSources.sources.find(s => s.value === attendeeId);

      if (!!source) {
        store.dispatch(
          takeGenericPresenterLive(
            source,
            {},
            setProgram,
            setAgoraAttendeeCameraStatus,
            toggleAgoraAttendeeMuteStatus
          )
        );
      }
    });

    // Used to sync director time to real-time server time when director first loads up

    this._socket.on(
      BROADCAST_JOIN_SYNCED_SERVER_TIME,
      async ({ serverTime }) => {
        const directorTime = moment().utc().unix();
        const now = moment.unix(directorTime);
        const then = moment.unix(serverTime);
        const serverTimeDelta = now.diff(then, 'seconds'); // Get seconds difference
        store.dispatch(setServerTimeDelta(serverTimeDelta));
      }
    );

    this._socket.on(
      KNOCK_UPDATED,
      ({
        attendeeId,
        name,
        description,
        presenterPhoto,
        userId,
        cameraUnavailable
      }) => {
        /**
         * If presenter is joining the meeting, we set details in state first as a way of
         * passing them to `setAttendeePresence` action which will create a source.
         */
        this._store.dispatch(
          setAttendeeDetails(
            attendeeId,
            name,
            description,
            presenterPhoto,
            SOURCE_ROLE_SPEAKER
          )
        );

        const { broadcastSources } = store.getState();

        const presenter = broadcastSources.sources.find(
          ({ value }) => value === attendeeId
        );

        /**
         * If presenter updates their details while already in the meeting and we have
         * them as a source, we just update that source.
         */
        if (presenter) {
          const payload = {
            title: name,
            description,
            userId,
            role: SOURCE_ROLE_SPEAKER,
            cameraUnavailable
          };

          this._store.dispatch(updateSource(presenter._id, payload));
        }
      }
    );

    this._socket.on(INITIALIZED_READINESS_CHECK, payload => {
      if (!!payload) {
        store.dispatch(createSandboxMeeting());
      }
    });

    this._socket.on(CANCELLED_REQUESTS, payload => {
      this._store.dispatch(cancelKnock(payload));
    });

    this._socket.on(ATTENDEE_SCREEN_SHARE_CANCELLED, attendeeId => {
      const { broadcastSources } = store.getState();
      store.dispatch(decreaseScreenShare());
      const { sources } = broadcastSources;

      const sourceValue = `${attendeeId}#content`;

      const source = sources
        .filter(({ type }) => type === SCREEN_PRESENTER)
        .find(({ value }) => value === sourceValue);
      /**
       * Source will be undefined if director approves screenshare as a new source.
       * This will only have value if screenshare was mapped to a placeholder.
       */
      if (source) {
        store.dispatch(
          updateSource(source._id, {
            value: UNASSIGNED
          })
        );
        store.dispatch(
          setIsInitializing(source.value, {
            isInitializing: false,
            isAttendee: true
          })
        );
      }

      const screenShareName = source?.title || 'Screen share';
      const message = `${screenShareName} was cancelled by presenter`;

      store.dispatch(
        showNotification(message, {
          timeout: 5500,
          type: 'alert'
        })
      );
    });

    this._socket.on(
      MULTIPLE_CAMERA_STATUSES_CHANGED,
      ({ attendeeCameraStatuses }) => {
        const {
          meeting: { attendeeResponse }
        } = store.getState();
        const attendeeId =
          attendeeResponse && attendeeResponse.Attendee.AttendeeId;
        const isCurrentAttendee =
          typeof attendeeCameraStatuses[attendeeId] === 'boolean';
        if (!isCurrentAttendee) {
          return;
        }
        const isCameraOn = attendeeCameraStatuses[attendeeId];
        store.dispatch(setAttendeeCameraStatus(attendeeId, isCameraOn));
      }
    );

    this._socket.on(SYNCED_BRANDING_SETTINGS, async ({ brandingSettings }) => {
      store.dispatch(syncBrandingSettings(brandingSettings));
    });

    this._socket.on(MIXER_TASK_FAILED, async ({ mixerTaskType }) => {
      const message = `We found an issue with a ${mixerTaskType}. Try restarting it for the best experience.`;
      store.dispatch(
        showNotification(message, {
          timeout: 5000,
          type: 'alert'
        })
      );
    });
  };
}

/**
 *
 * @param {*} socket
 * @param {*} store
 */
const socketConnected = (socket, store) => {
  socket.on('connect', () => {
    store.dispatch(clearModal(LOST_REALTIME_SOCKET_CONNECTION));
  });

  const {
    meeting: { attendeeResponse }
  } = store.getState();
  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };
  logger.info('Realtime socket connected', payload);
};

/**
 *
 * This function dispatches an event to get the most recent data from the api
 *
 * @param {Object} socket reference
 * @param {Object} store reference
 */
const socketReconnected = (socket, store) => {
  const socketIOSocket = socket.eject();
  socketIOSocket.io.on('reconnect', () => {
    // This was done to align pro/lite code
    // This will be moved to the socket package in the ticket below
    // https://jira.cvent.com/browse/WEBINAR-28554
    reconnectRealTimeMessage(store.dispatch, store.getState);
  });
};

function reconnectRealTimeMessage(dispatch, getState) {
  const {
    meeting: { attendeeResponse }
  } = getState();

  showWebSocketReconnectionMessage(dispatch);

  window.realtimeConnectionLostTimeout = null;
  dispatch(getCurrentBroadcast(true));

  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };

  logger.error('Realtime connection restored', payload);
}

const socketDisconnected = (socket, store) => {
  const socketIOSocket = socket.eject();
  socketIOSocket.on('disconnect', () => {
    const {
      meeting: { attendeeResponse },
      modal
    } = store.getState();

    // If the meeting has ended with no initialValue then do not show RealtimeErrorMessage modal
    const hasMeetingEnded =
      modal?.type === MEETING_ENDED_MODAL && !modal?.initialValue;

    if (!window.realtimeConnectionLostTimeout && !hasMeetingEnded) {
      window.realtimeConnectionLostTimeout = setTimeout(() => {
        showRealtimeErrorMessageModal(store.dispatch);
      }, REALTIME_CONNECTION_TIMEOUT_VALUE);
    }
    const payload = {
      attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
    };
    logger.error('Realtime connection lost', payload);
  });
};
